import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import withLoader from 'components/Shared/withLoader';
import { ReclamationFiltre } from '../../../../../constants';
import { ReclamationFiltreNoms } from '../../../../../constants';
import { yellow } from '@mui/material/colors';


const styles = theme => ({
    card: {
        height: '100%'
    },
    content: {
        display: 'flex',
        alignItems: 'center'
    },
    divider: {
        paddingTop: 16,
        paddingBottom: 16
    },
    avatar: {
        flex: '0 0 auto',
        marginRight: 12,
        width: 60,
        height: 60,
        color: '#fff',
        backgroundColor: yellow[700]
    },
    title: {
        flex: '1 1 auto',
        marginLeft: 12
    },
    link: theme.style.link
});

const IndicateurWithLoader = withLoader(
    ({ count }) => (<Typography variant="h6" gutterBottom>{count}</Typography>)
);

const NbReclamationsEmisesIndicateur = ({ classes, count, isLoading, onClick }) => (
    <Card className={classes.card} onClick={onClick}>
        <CardContent>
            <Link to={"/reclamations#" + ReclamationFiltreNoms[ReclamationFiltre.Toutes]} onClick={onClick} className={classes.link}>
                <div className={classes.content}>
                    <Avatar className={classes.avatar}>
                        <CreateNewFolderIcon />
                    </Avatar>
                    <div className={classes.title}>
                        <Typography variant="subtitle1" gutterBottom>Émis</Typography>
                        <IndicateurWithLoader isLoading={isLoading} count={count} />
                    </div>
                </div>
            </Link>
            <div className={classes.divider}>
                <Divider />
            </div>
            <Typography variant="caption">{`Nombre de dossiers après-vente en cours dont je suis l'émetteur`}</Typography>
        </CardContent>
    </Card>
);

NbReclamationsEmisesIndicateur.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(NbReclamationsEmisesIndicateur);